module.exports = __webpack_public_path__ + "static/media/ic_mastercard.34ce601e.png";